
$(document).ready(function () {
    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 1;
    var syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        slideTransition: 'linear',
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        nav: false,
        autoplay: true,
        dots: false,
        loop: true,
        responsiveRefreshRate: 200,
        navText: ['', ''],
    }).on('changed.owl.carousel', syncPosition);

    sync2
        .on('initialized.owl.carousel', function () {
            sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
            items: slidesPerPage,
            dots: false,
            nav: false,
            slideTransition: 'linear',
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            slideBy: slidesPerPage,
            responsiveRefreshRate: 10,
        }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {

        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }



        sync2.find(".owl-item").removeClass("current").eq(current) .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 1000, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 1000, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 1000, true);
        }
    }

    // sync2.on("click", ".owl-item", function (e) {
    //     e.preventDefault();
    //     var number = $(this).index();
    //     sync1.data('owl.carousel').to(number, 3000, true);
    // });

    $('.owl-next').click(function () {

        $('.owl-carousel').trigger('stop.owl.autoplay');

    }); 

   $('.button--primary').on('mousedown', function() {
    sync1.off('mousedown.owl.core');
  });
});

$(document).ready(function () {
    var sync3 = $("#sync3");
    var sync4 = $("#sync4");
    var sync_announce = $("#sync_announce");
    var slidesPerPage = 1;
    var syncedSecondary = true;

    sync3.owlCarousel({
        items: 1,
        slideTransition: 'linear',
        nav: true,
        autoplay: true,
        dots: true,
        loop: true,
        responsiveRefreshRate: 200,
        navText: ['', ''],
    }).on('changed.owl.carousel', syncPosition);

      sync_announce.owlCarousel({
        items: 1,
        slideTransition: 'linear',
        nav: true,
        autoplay: true,
        dots: true,
        loop: true,
        responsiveRefreshRate: 200,
        navText: ['', ''],
    }).on('changed.owl.carousel', syncPosition);

    sync4
        .on('initialized.owl.carousel', function () {
            sync4.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
            items: slidesPerPage,
            dots: false,
            nav: false,
            slideTransition: 'linear',
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            slideBy: slidesPerPage,
            responsiveRefreshRate: 10,
        }).on('changed.owl.carousel', syncPosition2);


    function syncPosition(el) {

        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }



        sync4
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync4.find('.owl-item.active').length - 1;
        var start = sync4.find('.owl-item.active').first().index();
        var end = sync4.find('.owl-item.active').last().index();

        if (current > end) {
            sync4.data('owl.carousel').to(current, 1000, true);
        }
        if (current < start) {
            sync4.data('owl.carousel').to(current - onscreen, 1000, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync3.data('owl.carousel').to(number, 1000, true);
        }
    }

    // sync4.on("click", ".owl-item", function (e) {
    //     e.preventDefault();
    //     var number = $(this).index();
    //     sync3.data('owl.carousel').to(number, 3000, true);
    // });

    $('.owl-next').click(function () {

        $('.owl-carousel').trigger('stop.owl.autoplay');

    });
$('.button--primary').on('mousedown', function() {
    sync3.off('mousedown.owl.core');
  });
});


$('#mob_view').owlCarousel({
                loop:true,
                margin:10,
                nav:false,
                items:1,
                dots:true,
                
            })


